interface DeviceNavigator {
  hardwareConcurrency?: number;
  /** Chrome and Edge only, rounded and capped by the browser. */
  deviceMemory?: number;
}

/** BRE-9948: machine power on every event, omitted where the browser doesn't report it. */
export function deviceProperties(nav: DeviceNavigator = navigator): Record<string, number> {
  return {
    ...(nav.hardwareConcurrency ? { device_cpu_cores: nav.hardwareConcurrency } : {}),
    ...(nav.deviceMemory ? { device_memory_gb: nav.deviceMemory } : {}),
  };
}
